import { render } from "./certificates-item.vue?vue&type=template&id=587248a6&ts=true"
import script from "./certificates-item.vue?vue&type=script&lang=ts"
export * from "./certificates-item.vue?vue&type=script&lang=ts"

import "./certificates-item.vue?vue&type=style&index=0&id=587248a6&lang=scss"

import exportComponent from "C:\\Users\\Link\\Documents\\MCOM\\mcom-agri-origin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__